import { Injectable } from "@angular/core";
import { BottomSheetHelperService } from "./bottomSheetHelper.service";
import { AccountPaymentService } from "./accountPayment.service";
import { AccountPaymentRequestDialogComponent } from "../modalDialogs/accountPaymentRequestDialog/accountPaymentRequestDialog.component";
import { AccountPaymentRequestDialogData } from "../shared/models/accountPayment.model";

/** Single entry point for opening the account-payment request dialog and submitting on confirm. */
@Injectable({
  providedIn: "root"
})
export class AccountPaymentRequestDialogService {

  constructor(
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _accountPaymentService: AccountPaymentService
  ) { }

  /** Opens the dialog; the cancel label default is owned by the dialog, not applied here. */
  public open(cancelButtonLangkey?: string): void {
    const me = this;
    const data: AccountPaymentRequestDialogData = { cancelButtonLangkey };
    me._bottomSheetHelperService.open(AccountPaymentRequestDialogComponent, {
      panelClass: "mat-bottom-sheet-container-medium",
      data,
    }).afterDismissed().subscribe((confirmed: boolean) => {
      if (confirmed) { me._accountPaymentService.submitActivationRequest(); }
    });
  }
}
